import { render, staticRenderFns } from "./TypistHub.vue?vue&type=template&id=195ed098&scoped=true"
import script from "./TypistHub.vue?vue&type=script&lang=js"
export * from "./TypistHub.vue?vue&type=script&lang=js"
import style0 from "./TypistHub.vue?vue&type=style&index=0&id=195ed098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ed098",
  null
  
)

export default component.exports